// Open House — choosing a freelancer: the requests dialog and what the project
// page shows after a request is accepted. Every string is approved, verbatim:
// docs/design/tuw/open-house/new-flow-wording.md §8 (declining), §9–11 (after
// accepting), §13 (requests table), §24 (each writer's price) and §31 (a
// cover designer's).
//
// A brief's kind (OrderBriefs::Requirement::KINDS) picks the role: "writing"
// and "sample" are a writer's, "editing" an editor's, "cover" a cover designer's.

const WRITER = {
  requests: "Writer requests",
  freelancer: "Writer",
  decline: "Decline writer’s request",
  declineH: "Decline this writer’s request?",
  declineB: "You’re declining this writer’s request to work on your project.",
  inviteWaits: "Your invited writer has accepted. Finish your brief before they can be assigned.",
  awaitConfirm: "Waiting for your writer to confirm before they’re assigned.",
  fDeclined: "This writer declined the project. Return to requests to choose another writer. Your brief is saved.",
  fUnconfirmed: "This writer didn’t confirm the project. Return to requests to choose another writer. Your brief is saved.",
}

const EDITOR = {
  requests: "Editor requests",
  freelancer: "Editor",
  decline: "Decline editor’s request",
  declineH: "Decline this editor’s request?",
  declineB: "You’re declining this editor’s request to work on your project.",
  inviteWaits: "Your invited editor has accepted. Finish reviewing your editing preferences before they can be assigned.",
  awaitConfirm: "Waiting for your editor to confirm before they’re assigned.",
  fDeclined:
    "This editor declined the project. Return to requests to choose another editor. Your editing preferences are saved.",
  fUnconfirmed:
    "This editor didn’t confirm the project. Return to requests to choose another editor. Your editing preferences are saved.",
}

// A bundle's cover order: its cover designer (new-flow-wording §31).
const DESIGNER = {
  requests: "Cover designer requests",
  freelancer: "Cover designer",
  decline: "Decline cover designer’s request",
  declineH: "Decline cover designer’s request?",
  declineB: "You’re declining this cover designer’s request to work on your project.",
  inviteWaits: "Your invited cover designer accepted. Finish your cover brief before they can be assigned.",
  awaitConfirm: "Your cover designer must confirm before being assigned.",
  fDeclined: "The cover designer declined your project. Choose another in requests. Your cover brief is saved.",
  fUnconfirmed: "This cover designer didn’t confirm the project. Choose another in requests. Your cover brief is saved.",
  requestPrice: "Cover designer’s price",
}

export const requestCopy = (kind) => (kind === "editing" ? EDITOR : kind === "cover" ? DESIGNER : WRITER)

export const REQUEST_WORDS = {
  mixedRequests: "Requests",
  rating: "Rating",
  requestedOn: "Requested on",
  noRequests: "No requests yet.",
  accepted: "Accepted",
  declineCta: "Decline request",
  requestPrice: "Writer’s price",
  // Today's live line, word for word (pages/Billing.jsx, the payment-due card).
  taxAtCheckout: "Tax is added at checkout.",
}

// The amount comes formatted (lib/openHouse/bookWritingSteps `money`).
export const acceptPrice = (kind, amount) => {
  if (kind === "sample") return `You’ll pay ${amount} for this sample after the writer is assigned.`
  if (kind === "cover") return `You’ll pay ${amount} after your cover designer is assigned.`
  return `You’ll pay ${amount} for this project after the writer is assigned.`
}

// The dialog's heading: one role's requests by that role, Open House requests
// of both roles as "Requests", and anything else as today.
export function requestsTitle(requests, today) {
  if (!requests.length || !requests.every((request) => request.openHouse)) return today

  const roles = new Set(requests.map((request) => requestCopy(request.brief?.kind).requests))
  return roles.size === 1 ? [...roles][0] : REQUEST_WORDS.mixedRequests
}
